import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const CreateCategorieModal = ({ show, handleClose, handleCreate }) => {
    const [newCategorie, setNewCategorie] = useState({ nom: '' });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setNewCategorie(prevCategorie => ({
            ...prevCategorie,
            [name]: name === 'image' ? files[0] : value,
        }));
    };

    const onCreate = () => {
        handleCreate(newCategorie);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Créer une nouvelle catégorie</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            name="nom"
                            value={newCategorie.nom}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={onCreate}>
                    Créer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateCategorieModal;
